import React from 'react';
import { Box, Typography } from '@mui/material';
import { LISTING_SYNC_COMING_SOON_COPY } from './listingIdFieldCopy';

/**
 * Shown under the Status updates toggle when Auto sync is not available yet.
 * Keeps the scaffold visible while explaining that sync is coming soon.
 */
const ListingSyncUnavailableNotice = () => (
  <Box
    sx={{
      p: 1.25,
      borderRadius: '10px',
      bgcolor: 'rgba(0,0,0,0.04)',
    }}
  >
    <Typography sx={{ fontSize: '0.78rem', color: 'rgba(0,0,0,0.58)', lineHeight: 1.5 }}>
      {LISTING_SYNC_COMING_SOON_COPY}
    </Typography>
  </Box>
);

export default ListingSyncUnavailableNotice;
